import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ValidateRequired } from '@shared/validators/required.validator';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog as MatDialog, MatDialogContent } from '@angular/material/dialog';
import { CrudService } from '@services/laravel/crud.service';
import { ToastrService } from 'ngx-toastr';
import { ValidateCpf } from '@shared/validators/cpf.validator';
import { RegisterComponent } from './../../../../../../src/app/components/register/register.component';
import { Router } from '@angular/router';
import { ModalHeaderComponent } from '../../../shared/components/modal-header/modal-header.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatInput, MatError } from '@angular/material/input';
import { TextMaskDirective } from '../../../shared/compat/text-mask.module';

import { MatButton } from '@angular/material/button';

@Component({
    standalone: true,
    selector: 'app-association-user-social',
    templateUrl: './association-user-social.component.html',
    styleUrls: ['./association-user-social.component.css'],
    imports: [ModalHeaderComponent, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormField, MatInput, TextMaskDirective, MatError, MatButton]
})
export class AssociationUserSocialComponent implements OnInit {

  public associationForm: UntypedFormGroup;
  public mask = {
    cpf: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
  };

  constructor(
    public dialogRef: MatDialogRef<AssociationUserSocialComponent>,
    private dialog: MatDialog,
    private crud: CrudService,
    private toastr: ToastrService,
    private _router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 

    this.associationForm = new UntypedFormGroup({
      'cpf_number': new UntypedFormControl(null, [ValidateCpf, ValidateRequired]),
      'password': new UntypedFormControl(null, [ValidateRequired])
    });
    
  }

  ngOnInit() {
  }

  association(){
    let obj = {
      "cpf_number": this.associationForm.value.cpf_number,
      "password": this.associationForm.value.password,
      "email": this.data.email,	
      "google_id": this.data.id
    };
    this.crud.post('associate-googleid', obj).then((res: any) => {

      this.dialogRef.close();

      sessionStorage.setItem('access_token', 'Bearer ' + res.access_token);
      sessionStorage.setItem('application', JSON.stringify(res.application));
      
      this.toastr.success('Login feito com sucesso.', 'Bem-vindo!');
      
      this._router.navigate(['/main/select-application']);

    }).catch((rej: any) => {

      if (rej.status == 404){
        this.dialogRef.close();
        return this.openDialog();
      }

    });
  }

  openDialog(){
    const dialogRef = this.dialog.open(RegisterComponent, {
      width: '80%',
      height: 'auto%',
      data: Object.assign({}, this.data, this.associationForm.value),
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      
    });
  }

  close = () => {
    this.dialogRef.close();
  }

}
